<template>
  <div style="color:#6c757d !important;">
    <!-- ----------------------------------- -->
    <!-- navbar starts -->
    <vs-navbar
      v-model="indexActive"
      :color="colorx"
      text-color="rgba(255,255,255,.6)"
      active-text-color="rgba(255,255,255,1)"
      class="myNavbar"
    >
      <div slot="title">
        <vs-navbar-title class="print-scr">Graphs Presentations</vs-navbar-title>
      </div>
    </vs-navbar>
    <!-- navbar ends -->
    <!-- ----------------------------------- -->
    <!-- container starts -->
    <div class="container container-bdr mt-5 mb-5">
      <!-- row starts -->
      <div class="row">
        <vs-breadcrumb
          align="left"
          :items="
                  [
                   {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Admin/adminDashboard'
                    },
                    {
                      title: 'No Of Trainees',
                      url: '/#/dashboard/Admin/trainingReport',
                      active: true
                    }
                  ]"
        ></vs-breadcrumb>
        <div class="col-sm-12">
          <span class="btn btn-primary float-right btn-sm print-btn" @click="printReport">
            <i class="material-icons">print</i> Print
          </span>
        </div>
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-12 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Pre & Post Assessment Report</strong>
            </span>
            <span class="float-right">
              <strong>Event Code :</strong> T327
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom">
          <img :src="BASEPATHDYNAMIC+'/unodc_logo.png'" class="mt-2 mb-2" alt="UNODC" width="200" />
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>{{trainingDetail.address}} Pakistan</strong>
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Country Office Pakistan</strong>
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-12 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Name of Event :</strong>
              {{trainingDetail.title}}
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-8 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Start Date :</strong>
              {{trainingDetail.startdate}}
            </span>
            <span class="float-right">
              <strong>Finish Date :</strong>
              {{trainingDetail.enddate}}
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Output :</strong> 2.1(PACT)
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-6 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Total Pre-Assessment Forms :</strong> 27
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-6 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Total Post-Assessment Forms :</strong> 27
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-12 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Name of Trainer(s) :</strong>
              <template v-if="trainerr">
                <span v-for="(trainer,tinde) in trainerr" :key="tinde">{{trainer.name}} -</span>
              </template>
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
      </div>
    </div>
    <!-- ----------------------------------- -->
    <!-- container starts -->
    <div class="container container-bdr mt-5 mb-5">
      <!-- row starts -->
      <div class="row">
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-6">
          <p class="mt-2 mb-2">
            <span>
              <h3 class="h-three">Training Report</h3>
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-6">
          <p class="mt-2 mb-2"></p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-5">
          <!-- --------------------------  -->
          <!-- nested row starts  -->
          <div class="row">
            <!-- --------------------------  -->
            <!-- nested column starts  -->
            <div class="col-md-12">
              <p class="mt-2 mb-2">
                <span>
                  <h5 class="h-five">{{trainingDetail.title}}</h5>
                </span>
              </p>
            </div>
            <!-- nested column ends  -->
            <!-- --------------------------  -->
            <!-- nested column starts  -->
            <div class="col-md-12">
              <p class="mt-2 mb-2">
                <span>
                  <strong>Conducted By -</strong>
                  <template v-if="trainerr">
                    <div v-for="(trainer,tinde) in trainerr" :key="tinde">{{trainer.name}}</div>
                  </template>
                </span>
              </p>
              <p class="mt-2 mb-2">
                <span>
                  <strong>Conducted On -</strong>
                  {{trainingDetail.startdate}}
                </span>
              </p>
            </div>
            <!-- nested column ends  -->
            <!-- --------------------------  -->
            <!-- nested column starts  -->
            <div class="col-md-12">
              <p class="mt-2 mb-2">
                <span v-if="trainessArray">
                  <strong style="text-transform:uppercase;">List of Participants</strong>
                  ({{trainessArray.length}})
                </span>
              </p>
              <ul class="participants-list" v-if="trainessArray">
                <li v-for="(trainee,index) in trainessArray" :key="index">{{trainee.trainee.userstrainee.name}}</li>
              </ul>
            </div>
            <!-- nested column ends  -->
          </div>
          <!-- nested row ends  -->
          <!-- --------------------------  -->
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-7">
          <!-- --------------------------  -->
          <!-- nested row starts  -->
          <div class="row">
            <!-- --------------------------  -->
            <!-- nested column starts  -->
            <div class="col-md-6">
              <p class="mt-5 mb-2 text-center">
                <span>
                  <h5 class="h-five">Male/Female</h5>
                </span>
              </p>
              <canvas id="myPieChart" width="400" height="400"></canvas>
            </div>
            <!-- nested column ends  -->
            <!-- --------------------------  -->
            <!-- nested column starts  -->
            <div class="col-md-6">
              <p class="mt-5 mb-2 text-center">
                <span>
                  <h5 class="h-five">Knowledge Change</h5>
                </span>
              </p>
              <canvas id="bar-chart-grouped" width="400" height="400"></canvas>
            </div>
            <!-- nested column ends  -->
            <!-- --------------------------  -->
            <!-- --------------------------  -->
            <!-- nested column starts  -->
            <!-- Question 1 starts  -->
            <div class="col-md-12" v-for="(question,qindex) in questionsArray" :key="qindex">
              <p class="mt-5 mb-2">
                <span>
                  <h5 class="h-five">Question No. {{qindex+1}}</h5>
                </span>
              </p>
              <p class="mt-2 mb-2">
                <span>
                  <h6 class="h-six">{{question.question.title}} ?</h6>
                </span>
              </p>
              <canvas :id="'question'+qindex" width="400" height="150"></canvas>
            </div>
          </div>
          <!-- nested row ends  -->
          <!-- --------------------------  -->
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
      </div>
      <!-- row ends -->
    </div>
    <!-- container ends -->
  </div>
</template>

<script>
import axios from "axios";
import Chart from "chart.js";


export default {
  data: () => ({
    colorx: "#2196f3",
    BASEPATHDYNAMIC: "",
    training_id: "",
    trainessArray: [],
    questionsArray: [],
    optionsArray: [],
    selectedOptions: [],
    trainerr: [],
    counterSelectedOptions: 0,
    counterA : 0,
    labelArray: [],
    trainingDetail: [],
    malecount: 0,
    femalecount: 0,
    indexActive: 1
  }),
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    // chart 1 starts
    this.BASEPATHDYNAMIC = localStorage.getItem("BASE_PATH");
    this.training_id = this.$route.query.trainingId;
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/single/training/traineedetails/report/get/" +
          this.training_id
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        if (response.data && response.data.trainees != undefined) {
          this.trainessArray = response.data.trainees;
        }
        if (response.data && response.data.training != undefined) {
          this.trainingDetail = response.data.training;
        }
      });
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/single/training/traineedetails/report/gender/get/" +
          this.training_id
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        if (response.data.male != undefined) {
          this.malecount = response.data.male;
        }
        if (response.data.female != undefined) {
          this.femalecount = response.data.female;
        }
       
        
      });
    //get all trainer
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/single/training/traineedetails/trainer/get/" +
          this.training_id
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.trainerr = response.data;
      });
    //get pre assesment questions
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/single/training/pre-assesment/report/get/" +
          this.training_id
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        if (
          response.data &&
          response.data.preassesment &&
          response.data.options
        ) {
          setTimeout(() => {
            response.data.questions.forEach((element) => {
              response.data.options.forEach((opt, index) => {
                this.labelArray = [];
                this.selectedOptions = [];
                opt.forEach((oneopt, optindex) => {
                  if (oneopt.questionBank_id == element.question_id) {
                    
                     this.selectedOptions.push(0);
                    response.data.preassesment.forEach((asses) => {
                       if (asses.option_id == oneopt.id) {
                      this.selectedOptions[optindex] = this.selectedOptions[optindex] + 1
                    }
                    })
                   
                    if (opt.length == optindex + 1) {
                      this.labelArray.push(oneopt.title);
                      new Chart(document.getElementById("question" + index), {
                        type: "horizontalBar",
                        data: {
                          labels: this.labelArray,
                          datasets: [
                            {
                              label: "",
                              backgroundColor: [
                                "#3e95cd",
                                "#8e5ea2",
                                "#3cba9f",
                                "#e8c3b9",
                                "#c45850"
                              ],
                              data: this.selectedOptions
                            }
                          ]
                        },
                        options: {
                          scales: {
                            xAxes: [
                              {
                                ticks: {
                                  min: 0,
                                  max: 100,
                                  callback: function(value) {
                                    return value + "%";
                                  }
                                },
                                scaleLabel: {
                                  display: true,
                                  labelString: ""
                                }
                              }
                            ]
                          },
                          legend: { display: false }
                        }
                      });
                    } else {
                      this.labelArray.push(oneopt.title);
                    }
                  }
                  this.counterA++;
                });
              });
            });
          }, 1000);
          this.questionsArray = response.data.questions;
        }
      });

    
    
  },
  methods: {
    printReport: function() {
      window.print();
    }
  }
};
</script>
<style scoped>
.myNavbar {
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1), 0 5px 5px rgba(0, 0, 0, 0.1) !important;
}
/* .container-bdr {
  border-top: 1px solid #ebe9e9;
  border-right: 1px solid #ebe9e9;
} */
/* .col-bdr-bottom {
  border-bottom: 0.5px solid #ebe9e9;
  border-left: 0.5px solid #ebe9e9;
} */
.nav-route-link {
  background: none !important;
  border-right: 0px !important;
}
.h-three {
  color: #2196f3 !important;
}
.h-five {
  font-size: 18px;
}
.h-six {
  font-size: 16px;
}
ul.participants-list li {
  padding: 5px 0px;
}
/* .cont-bdr {
  display: none;
} */
@media print {
  .print-scr {
    display: none;
  }
  .print-btn {
    display: none;
  }
  .cont-bdr {
    display: block;
  }
  .heading {
    display: none;
  }
}
</style>
<style>
.vs-navbar--header {
  height: 60px;
  padding: 20px;
}
.vs-con-items {
  padding: 20px;
}

@media screen and (max-width: 800px) {
  .vs-con-items.activeMenuResponsive {
    background-color: #46637a !important;
  }
}
</style>